import { render, staticRenderFns } from "./ArticleModal.vue?vue&type=template&id=06f6fcca&scoped=true&"
import script from "./ArticleModal.vue?vue&type=script&lang=js&"
export * from "./ArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6fcca",
  null
  
)

export default component.exports